import { P, H6, Row } from '@workramp/ui';
import styled from 'styled-components';

const ICON_SIZE = 8;
const CARD_PADDING_Y = 4;
const CARD_PADDING_X = 5;

export const CardWrapper = styled.div<{ $hasIcon?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radii.xl}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
  box-shadow: ${({ theme }) => theme.shadows[100]};
  border: 1px solid ${({ theme }) => theme.colors.on[100]};
  transition: box-shadow ${({ theme }) => theme.motion.duration.short}ms ease-in-out;
  height: 100%;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[300]};
  }
`;

export const BackgroundImg = styled.img`
  display: block;
  height: ${({ theme }) => theme.spacing(28)}px;
  width: 100%;
  object-fit: cover;
  border-top-left-radius: ${({ theme }) => theme.radii.xl}px;
  border-top-right-radius: ${({ theme }) => theme.radii.xl}px;
`;

export const CardBody = styled.div<{ $hasBackgroundImg?: boolean; $hasIcon?: boolean; $maxCardHeight?: number }>`
  padding: ${({ theme }) => theme.spacing(CARD_PADDING_Y)}px ${({ theme }) => theme.spacing(CARD_PADDING_X)}px;
  margin-top: ${({ $hasBackgroundImg, $hasIcon, theme }) =>
    $hasBackgroundImg && $hasIcon ? -theme.spacing(1 + CARD_PADDING_Y + ICON_SIZE / 2) : 0}px;
  height: ${({ $maxCardHeight }) => `${$maxCardHeight}px` || null};
`;

export const CardFooter = styled.div`
  height: ${({ theme }) => theme.spacing(12)}px;
  margin-left: ${({ theme }) => theme.spacing(CARD_PADDING_X)}px;
  margin-right: ${({ theme }) => theme.spacing(CARD_PADDING_X)}px;
  border-top: 1px solid ${({ theme }) => theme.colors.on[100]};
  margin-top: auto;

  & p,
  & a,
  & span {
    font-weight: 500;
  }
`;

export const FullHeightRow = styled(Row)`
  height: 100%;
`;

export const ActionsWrapper = styled.div`
  position: relative; // Move above the interactive card overlay so actions are clickable
  z-index: 2;
`;

export const IconWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radii.lg}px;
  box-shadow: ${({ theme }) => theme.shadows[100]};
  height: ${({ theme }) => theme.spacing(ICON_SIZE)}px;
  width: ${({ theme }) => theme.spacing(ICON_SIZE)}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
`;

export const Description = styled(P)`
  position: relative;
  z-index: 2;
  color: ${({ theme }) => theme.colors.on[500]};
  cursor: pointer;
  overflow-wrap: anywhere;
`;

export type BannerWrapperProps = {
  $variant: 'primary' | 'secondary' | 'danger';
};

export const BannerWrapper = styled(P)<BannerWrapperProps>`
  position: absolute;
  top: ${({ theme }) => theme.spacing(CARD_PADDING_Y)}px;
  right: -${({ theme }) => theme.spacing(2)}px;
  padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(2)}px;
  border-radius: ${({ theme }) => theme.radii.lg}px;
  color: ${({ theme }) => theme.colors.on[0]};
  background-color: ${({ theme, $variant }) => theme.colors[$variant][700]};
`;

export const ActionText = styled(P)`
  color: ${({ theme }) => theme.colors.decorative.neutral[700]};
`;

export const Subtitle = styled(P)`
  position: relative;
  color: ${({ theme }) => theme.colors.on[500]};
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  cursor: pointer;
`;

export const Title = styled(H6)`
  position: relative;
  cursor: pointer;
  overflow-wrap: anywhere;
`;
